















































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Person from '@/types/Person.interface'
import PersonProfile from '@/components/PersonProfile.vue'
import PersonsQueue from '@/components/PersonsQueue.vue'
import modelsMixin from '@/mixins/models-mixin'
import blockedMixin from '@/mixins/blocked-contacts-mixin'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import IListTile from '@/types/components/IListTile.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import Button from '@/types/components/Button.interface'
import IList from '@/types/components/IList.interface'
import AddToGroupForm from '@/components/AddToGroupForm.vue'
import ContactsEmpty from '@/components/ContactsEmpty.vue'
import PersonsAutocomplete from '@/components/PersonsAutoComplete.vue'
export default Vue.extend({
    mixins: [modelsMixin, blockedMixin],
    components: {
        AddToGroupForm,
        ContactsEmpty,
        PersonProfile,
        PersonsAutocomplete,
        PersonsQueue
    },
    data() {
        return {
            //  Determines if we are currently deleting contacts
            deleting: false,
            //  Our loader we display at the top of our ilist
            loader: false,
            //  Determines if our add to group form menu is displayed or not
            menu: false,
            //  Indicates if the component has been mounted (we use this to make sure $refs exist)
            mounted: false,
            //  The IListPlaceholder for the persons list
            personsListPlaceholder: {
                content: 'No Contacts Found'
            },
            //  Determines if we are showing the search results list or not
            searched: false,
            // Tracks the number of multi-selected contacts
            selectedContactsSize: 0,
            //  Determines if we display our contacts empty component
            showEmptyState: false,
            //  The toolbar displayed above the content panel
            toolbar: {
                title: 'Contacts',
                help: {
                    title: 'Manage your Contacts',
                    body: 'Here you can upload new contacts, update existing contacts, create custom fields or select multiple contacts at once to quickly create groups. For more help, feel free to check out the resource below!',
                    button: {
                        text: 'Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/4544207-contacts-module-overview`
                    }
                }
            }
        }
    },
    beforeDestroy() {
        //  When navigating away make sure we unset our person
        this.selectedPerson = null
    },
    beforeRouteLeave(to, from, next) {
        //  Check if changes have been made to the Person
        this.interuptNavigation(next)
    },
    mounted() {
        //  Check if a person is set in the url params
        const id = this.$route.query.id

        //  If a person id is set, load it
        if (id) this.$store.dispatch('contactsSelectedPersonGet', id)

        //  Check if we have a showEmpty query param
        const showEmpty = this.$route.query.showEmpty

        //  If we do then set our showEmptyState to true
        if (showEmpty) this.showEmptyState = true

        //  We use this mounted variable to track when dom elements have been rendered
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            isApp: 'isApp',
            personsParams: 'contactsPersonsParams',
            lastPage: 'contactsPersonsLastPage',
            scrollPositionLeft: 'scrollPositionLeft',
            paginating: 'contactsPaginating',
            tenant: 'tenant',
            userHasPermission: 'userHasPermission'
        }),
        //  Determines if a user can interact with the delete buttons
        canDelete(): boolean {
            //  Users can delete contacts as long as they are AT LEAST a manager
            return (
                this.$store.getters.userHasPermission(2) &&
                this.tenant.data_provider !== 'QBO'
            )
        },
        canDeleteText(): string {
            //  If this is a QBO tenant then that takes highest priority
            if (this.tenant.data_provider === 'QBO') {
                return "Workspaces that are integrated with QBO cannot delete contacts from MessageDesk. If you'd like to delete a contact, you have to delete them from your QBO account."
            }

            //  Else, if this is because of user permission then inform about that error
            if (!this.$store.getters.userHasPermission(2)) {
                return "Operators do not have permission to delete contacts. Please contact your account's admin to perform this task or have them update your account permission."
            }
        },
        contactsEmpty(): boolean {
            //  If we searched, return false
            if (this.searched) return false

            //  Grab our persons query
            const query = this.$store.getters.contactsPersonsQueryFilter

            //  If we filtered, return false
            if (query && query.queries.length > 0) return false

            //  Grab our persons
            const persons = this.persons

            //  Filter out our "Josh Product Manager" contact (a pre-seeded)
            const filtered = persons.filter(
                (x: Person) => x.name_full !== 'Josh Product Manager'
            )

            //  Else, base it on our total number of contacts
            return !filtered.length
        },
        //  Dertermines if we are currently on a mobile device
        isMobile(): boolean {
            return this.$store.getters.isMobile()
        },
        //  Returns an array of multi-selected personIds
        multiSelectedPersonIds(): number[] {
            //  If the personsIList does NOT exist, return empty array
            if (!this.personsIList) return []

            //  Assemble an array of multi-selected person ids
            const ids = this.personsIList.multiSelected.map((person: Person) => person.id)

            //  Return the person ids
            return ids
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        //  We display our paginated list UNLESS we are searching, in which case we just use a temp list
        persons(): Person[] {
            //  If we are searching then display our temporary list
            if (this.searched) return this.searchResults
            //  Else, just display the contactsPersons
            else return this.$store.getters.contactsPersons
        },
        personsIList(): IList {
            return this.$store.getters.iList('contactsPersonsList')
        },
        //  The search results of our searched for persons
        searchResults: {
            get(): Person {
                return this.$store.getters.contactsSearchedPersons
            },
            set(val: Person[]): void {
                this.$store.commit('contactsSearchedPersonsSet', val)
            }
        },
        //  The person currently selected in the ilist
        selectedPerson: {
            get(): Person {
                return this.$store.getters.contactsSelectedPerson
            },
            set(person: Person): void {
                this.$store.commit('contactsSelectedPersonSet', person)
            }
        },
        //  Our tools we display on the top toolbar for managing contacts when NOT multiselected
        toolsDefault(): Button[] {
            return [
                {
                    text: 'Add Contact',
                    icon: 'mdi-account-plus',
                    color: 'primary',
                    callback: () => this.popNewContact()
                },
                {
                    text: 'Import Contacts',
                    icon: 'mdi-arrow-expand-up',
                    color: 'primary',
                    disabledPopup: !this.$store.getters.userHasPermission(2),
                    disabledPopupText:
                        "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                    hidden: this.isQBOXeroUser() || this.isApp || this.isMobile,
                    callback: () => this.$router.push('/csv/import')
                }
            ]
        }
    },
    methods: {
        //  Adds a contact to the queue and clears out our list of selected contacts
        addToPersonsQueue(): void {
            //  Get the persons from multi-select
            const persons = this.personsIList.multiSelected

            //  Add the multiselected persons to the personsQueue
            this.$store.commit('personsQueueAdd', persons)

            //  Clear multiselected persons
            this.$refs.personsList.multiSelectReset()
        },
        //  Close the persons profile
        closeProfile(hotKeyPressed: boolean = false): void {
            // True/false value if hotkey was used to activate function
            const hotKeyPressedAndOn = hotKeyPressed && this.hotKeysEnabled.enabled

            // True/false value if click was used to activate function
            const clickPress = !hotKeyPressed

            // If our hotkeys aren't on and the event wasn't activated with a click we leave the function
            if (!hotKeyPressedAndOn && !clickPress) {
                return
            }

            // Go to the first step
            this.$refs.contactsPanel.step = 1

            //  Unset our person
            this.unsetPerson()
        },
        //  Delete a single contact
        deleteContact(person: Person): void {
            //  Get the persons name
            const name = this.$options.filters.personFullNameOrEmail(person)

            //  Get confirmation from the user
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Contact?',
                icon: 'bi-trash-fill',
                text: `Are you sure you want to delete <b>${name}</b>?`,
                callback: async (result: boolean) => {
                    //  If the user answered 'NO', do nothing
                    if (!result) return

                    //  Else, start the loading spinner
                    this.loader = true

                    //  Delete the person
                    const response = await this.$store.dispatch(
                        'personsDelete',
                        person.id
                    )

                    //  Stop the loading spinner
                    this.loader = false

                    //  If the request failed, no nothing
                    if (!response) return

                    //  Else, notify the user of success
                    this.$store.commit('appNotificationBarSet', {
                        message: 'Contacts Deleted'
                    })
                }
            })
        },
        //  Delete multiple contacts
        deleteContacts(): void {
            //  Get the selected contacts ids
            const ids = this.multiSelectedPersonIds

            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Contacts?',
                icon: 'bi-trash-fill',
                text: `Are you sure you want to delete ${ids.length} contact(s)?`,
                callback: async (result: boolean) => {
                    //  If the user answered 'NO' do nothing
                    if (!result) return

                    //  Start our deleting spinner and loader
                    this.deleting = true
                    this.loader = true

                    //  Send the request
                    const response = await this.$store.dispatch('personsDeleteBatch', ids)

                    //  Stop our deleting spinner and loader
                    this.deleting = false
                    this.loader = false

                    //  If the request failed, do nothing
                    if (!response) return

                    //  Else, reset multi-selected items
                    this.$refs.personsList.multiSelectReset()

                    //  Notify the user of success
                    this.$store.commit('appNotificationBarSet', {
                        message: 'Contacts Deleted'
                    })
                }
            })
        },
        //  Interupt naviagation to check if we need to save chanes to the selected Person
        interuptNavigation(callback: Function) {
            //  Check if the currently loaded person has been changed (ie needs to be saved)
            const save = this.$refs.personProfile && this.$refs.personProfile.edited

            //  If we do NOT need to save changes, continue
            if (!save) return callback()

            //  Else, pop the confirm changes dialog
            this.$refs.personProfile.confirmChanges(callback)
        },
        isQBOXeroUser(): boolean {
            //  Grab the tenant's data provider
            const provider = this.tenant.data_provider

            //  If provider is null, return false
            if (!provider) return false

            //  Else, check if they are QBO or Xero
            const isQBOXeroUser =
                provider.toLowerCase() === 'qbo' || provider.toLowerCase() === 'xero'

            //  Return true if they are QBO or Xero
            return isQBOXeroUser
        },
        //  Handle the click event on disabled FilterButton and Search
        onDisabledClick(): void {
            //  Check if the filter button and searchbar are disabled
            const disabled = this.personsIList.multiSelect

            //  If the components are NOT disabled, do nothing
            if (!disabled) return

            //  Else, pop selection warning message
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Disabled',
                icon: 'mdi-information',
                yesText: 'Save for later',
                text: `Filters and Search are disabled while items are selected.  Do you want to save your selections now?`,
                callback: (result: boolean) => {
                    //  If the user answered 'NO', do nothing
                    if (!result) return

                    //  Else, save the selections to the PersonsQueue
                    this.addToPersonsQueue()
                }
            })
        },
        //  Track selected items in the personsList.  Binds the selected iList person, to the selected slot
        onPersonSelected(person: Person): void {
            //  Check if the person is different form the currently selected person
            const isNew = !this.selectedPerson || this.selectedPerson.id != person.id

            //  The 'next' function contains all the stuff we need to do when a contact is selected (this allows us to pass the handler to other components as a callback)
            const next = () => {
                //  Set the step to 2 (for mobile layout only)
                this.$refs.contactsPanel.step = 2

                //  If the channel is NOT different fromt he current selectetd person, do nothing
                if (!isNew) return

                //  Clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
                const query = Object.assign({}, this.$route.query)

                //  Update the person query param (there is watcher on this value that handles fetching the person)
                query.id = person.id

                //  Update the current url
                this.$router.push({ query })
            }

            //  If this is a new person, we need to check for changes before continuing
            if (isNew) return this.interuptNavigation(next)

            //  Else, just navigate to step 2 of the mobile interface
            this.$refs.contactsPanel.step = 2
        },
        onUploadContacts(): void {
            //  Close our empty state
            this.showEmptyState = false

            //  If our route contains "showEmpty" then remove the query
            if (this.$route.query.showEmpty) {
                //  Remove our query param
                const query = Object.assign({}, this.$route.query)

                //  Update our route
                this.$router.push({ query })
            }

            //  Open our form
            this.popNewContact()
        },
        //  Remove items in personsList and set showLoad to true
        onSearchCleared(): void {
            //  Set our search bool to false
            this.searched = false

            //  Set our temporary persons list to empty
            this.searchResults = null
        },
        onSearchCompleted(persons: Person[]): void {
            this.searchResults = persons

            this.searched = true
        },
        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.personsParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage
            this.$store.commit('contactsPersonsParamsSet', params)

            //  Paginate the next page
            this.$store.dispatch('contactsPersonsPaginate')
        },
        //  Our IListActions for our person, this is a menu containing buttons
        personActions(person: Person): IListAction {
            //  Create our buttons
            const menu: Button[] = [
                {
                    icon: 'mdi-message-processing',
                    color: 'primary',
                    text: 'Send Message',
                    callback: () =>
                        this.$router.push(`/inbox?channel=${person.primary_channel_id}`)
                },
                {
                    icon: 'bi-trash-fill',
                    color: 'primary',
                    text: 'Delete',
                    hidden: this.tenant.data_provider === 'QBO',
                    disabledPopup: this.operator,
                    callback: () => this.deleteContact(person)
                },
                {
                    icon: 'mdi-account-cancel',
                    color: 'grey',
                    text: this.blockedContactTooltip(person),
                    callback: () => this.toggleBlock(person),
                    disabledPopup: this.operator,
                    hidden: !this.$options.filters.phone(person.phone_default?.msisdn)
                }
            ]

            //  Create our IListAction
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  Return our newly created actions
            return action
        },
        //  The IListIcon bound to the persons list
        personIcon(person: Person): IListIcon {
            //  Get our icon from the vue filter
            const icon = this.$options.filters.personIcon(person)

            //  Create our IListIcon object
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return our IListIcon object
            return listIcon
        },
        //  The persons tile bound to the persons list
        personTile(): IListTile {
            return {
                actionColor: (person: Person) =>
                    this.$options.filters.personColor(person),
                actionContent: (person: Person) => this.personActions(person),
                color: (person: Person) => this.$options.filters.personColor(person),
                leftFooter: (person: Person) => this.$options.filters.personType(person),
                leftIcon: (person: Person) => this.personIcon(person),
                line1: (person: Person) =>
                    this.$options.filters.personFullNameOrEmail(person),
                line2: (person: Person) => person.company,
                line3: (person: Person) =>
                    this.$options.filters.personDefaultPhone(person),
                callback: (person: Person) => this.onPersonSelected(person)
            }
        },
        //  Pop a new contact form
        popNewContact(model: Person): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Add Contact',
                icon: 'mdi-account',
                color: 'primary',
                component: 'new-contact-selector',
                props: {
                    model: this.newPerson(),
                    withImport: true
                },
                callback: async (person: Person) => {
                    //  If the request failed, do nothing
                    if (!person) return null

                    //  Else, add the new contact to the top of the personsList
                    this.selectedPerson = person

                    //  close the app dialog
                    this.$store.dispatch('dialogClose', 'APP')
                }
            })
        },
        //  Pops open our query filter so we can apply queries to our persons list
        popQueryFilter(): void {
            //  create a memento of the currently selcted query filter
            const memento = window._.cloneDeep(this.$store.getters.personsQueryFilter)

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Filter Contacts',
                icon: 'bi-filter-circle-fill',
                component: 'persons-query-filter',
                callback: async (query) => {
                    //  Close the dialog
                    this.$store.dispatch('dialogClose', 'APP')

                    //  Else, check if any changes were made to an existing query fitler
                    const changed = !window._.isEqual(query, memento)

                    //  If the query filter has NOT changed, we dont need to do anything
                    if (!changed) return

                    //  Else, start the loader
                    this.loader = true

                    //  Assemble persons pagination params
                    const params = { page: 1, query: query }

                    //  A query filter was selected so we need to repaginate the persons list
                    await this.$store.dispatch('contactsPersonsGetQuery', params)

                    this.loader = false
                }
            })
        },
        unsetPerson(): void {
            //  Set our person to null
            this.selectedPerson = null

            //  Grab our current path
            const path = this.$route.path

            //  If the path is NOT inbox we are done
            if (!path.includes('contacts')) return

            //  If our query does not have an id, we are done
            if (!this.$route.query.id) return

            //  Remove the id query params from the route
            this.$router.replace({ id: {} })
        }
    },
    watch: {
        $route(to, from): void {
            //  If the 'id' query param does nOT exist, unset our data
            if (!to.query.id) return this.unsetPerson()

            //  Get the person id from the query param
            const id = to.query.id

            //  Check if the 'person' param is different from the currently loaded person
            const needsLoad = !this.selectedPerson || id != this.selectedPerson.id

            //  If we do NOT need to load, do nothing
            if (!needsLoad) return

            //The store watch function gets triggered by the $route watch function in the case that the person needs to be loaded.
            //  Else, fetch the new person
            this.$store.dispatch('contactsSelectedPersonGet', id)
        },
        scrollPositionLeft(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        }
    }
})
